(function() {

	$( '.order-status-form' ).validate();

	var searchParams = new URLSearchParams( window.location.search );
	if( searchParams.get( 'last_name' ) ) {

		$( '#last-name' ).val( searchParams.get( 'last_name' ) );

	}

	if( searchParams.get( 'email' ) ) {

		$( '#email' ).val( searchParams.get( 'email' ) );

	}

	var form = $( '.order-status-form' );

	if( searchParams.get( 'last_name' ) && searchParams.get( 'email' ) ) {

		$( '.loader' ).toggleClass( 'active' );

		$.ajax({
			url : window.theme.yes_video_api_url + '/api/v1/order_status?last_name=' + searchParams.get( 'last_name' ) + '&search_term=' + searchParams.get( 'email' ) + '&offset=0',
			headers : {
				'Accept' : 'application/json',
				'Content-type' : 'application/json',
				'X-Shopify-Shop-Domain' : window.theme.yes_video_api_x_domain,
				'Authorization' : 'Bearer ' + window.theme.yes_video_bearer_token
			},
			type : 'GET',
			dataType : 'json',
			success : function( data ) {

				var results = '';

				if( data.orders.length > 0 ){

					$.each( data.orders, function( i, order ){

						results += renderLineItem( order, searchParams.get( 'email' ) );

					});

					$( '.loader' ).toggleClass( 'active' );

					$( '.template-page-body-order-inner-footer' ).addClass( 'active' );
					$( '.template-page-body-order-inner-footer-order-status-table' ).addClass( 'active' );
					$( '.template-page-body-order-inner-footer-order-status-table-body' ).html( results );

					if( data.total_pages > 1 ){

						var pagination = '<button class="pagination-page-button previous" disabled>Previous</button>';
						pagination +='<div>' ;

						for ( var i = 0; i < data.total_pages; i++ ) {

							if( i === 0 ) {

								pagination += "<button aria-label='Page " + ( i ) + "' class='pagination-page-button active' value=" + ( i ) + " disabled><strong>" + ( i + 1 ) + "</strong></button>";

							} else {

								pagination += "<button aria-label='Page " + ( i ) + "' class='pagination-page-button' value=" + ( i ) + ">" + ( i + 1 ) + "</button>";

							}

						}

						pagination += '</div>';
						pagination += '<button class="pagination-page-button next" value="1">Next</button>'

						pagination += '<input type="hidden" class="last-name" value=' + searchParams.get( 'last_name' ) + ' />'
						pagination += '<input type="hidden" class="email" value=' + searchParams.get( 'email' ) + ' />'
						pagination += '<input type="hidden" class="current-page" value=' + 1 + ' />'
						pagination += '<input type="hidden" class="offset" value=' + data.offset + ' />'

						$( '.template-page-body-order-inner-footer-order-status-pagination' ).html( pagination );

					}


				} else {

					$( '.loader' ).toggleClass( 'active' );

					$( '.template-page-body-order-inner-footer' ).addClass( 'active' );
					$( '.template-page-body-order-inner-footer-order-status-table-error' ).html( '<div class="card-notice block p-5 my-8 border border-green-default bg-white text-center rounded wg-translate"><p>No orders found.</p></div>' );
					$( '.template-page-body-order-inner-footer-order-status-table-error' ).toggleClass( 'active' );

				}

			},
			error : function( err ){
				window.theme.functions.triggerAlert( 'Sorry an error occurred.', 'error' );
			}
		})

	}

	var renderLineItem = function( order, email ){

		var placedDate = new Date( order.placed_at );
		var formattedPlacedDate = ( placedDate.getMonth() + 1 ) + '/' + placedDate.getDate() + '/' + placedDate.getFullYear();

		return '<a class="order-status-results-item wg-translate" href="' + ( ( window.theme.order_templates && window.theme.order_templates.template_order_single ) ? window.theme.order_templates.template_order_single + '?reference_number=' + order.number.toString() + '&last_name=' + order.last_name : '#' ) + '&email=' + email +'">' +
			'<div class="order-status-results-item-left">' +
			'<p>Order #</p>' +
			'<h3>' + order.number + '</h3>' +
			'</div>' +
			'<div class="order-status-results-item-right">' +
			'<div>' +
			'<p>Placed</p>' +
			'<p class="value">' + formattedPlacedDate +'</p>' +
			'</div>'+
			'<div>' +
			'<p>Order Status</p>' +
			'<p class="value">' + order.external_status + '</p>' +
			'</div>' +
			'</div>' +
			'</a>';

	}

	// order status ajax
	form.on( 'submit', function( event ){

		event.preventDefault();

		var data = $( this ).serializeArray();
		var lastName = data[ 0 ].value;
		var email = data[ 1 ].value;

		var href = new URL( window.location.href );

		href.searchParams.set( 'last_name', lastName );
		href.searchParams.set( 'email', email );

		if ( history.pushState ) {

			window.history.pushState( { path : href.toString() }, '', href.toString() );

		}

		if( form.valid() ) {

			$( '.template-page-body-order-inner-footer' ).removeClass( 'active' );
			$( '.template-page-body-order-inner-footer-order-status-table-error' ).html( '' );
			$( '.template-page-body-order-inner-footer-order-status-table-error' ).removeClass( 'active' );

			$( '.template-page-body-order-inner-footer-order-status-table' ).removeClass( 'active' );

			$( '.template-page-body-order-inner-footer-order-status-pagination' ).html( '' );

			$( '.loader' ).toggleClass( 'active' );

			$.ajax({
				url : window.theme.yes_video_api_url + '/api/v1/order_status?last_name=' + lastName + '&search_term=' + email + '&offset=0',
				headers : {
					'Accept' : 'application/json',
					'Content-type' : 'application/json',
					'X-Shopify-Shop-Domain' : window.theme.yes_video_api_x_domain,
					'Authorization' : 'Bearer ' + window.theme.yes_video_bearer_token
				},
				type : 'GET',
				dataType : 'json',
				success : function( data ) {

					var results = '';

					if( data.orders.length > 0 ){

						$.each( data.orders, function( i, order ){

							results += renderLineItem( order, email );

						});

						$( '.loader' ).toggleClass( 'active' );

						$( '.template-page-body-order-inner-footer' ).addClass( 'active' );
						$( '.template-page-body-order-inner-footer-order-status-table' ).addClass( 'active' );
						$( '.template-page-body-order-inner-footer-order-status-table-body' ).html( results );

						if( data.total_pages > 1 ){

							var pagination = '<button class="pagination-page-button previous" disabled>Previous</button>';
							pagination +='<div>' ;

							for ( var i = 0; i < data.total_pages; i++ ) {

								if( i === 0 ) {

									pagination += "<button aria-label='Page " + ( i ) + "' class='pagination-page-button active' value=" + ( i ) + " disabled><strong>" + ( i + 1 ) + "</strong></button>";

								} else {

									pagination += "<button aria-label='Page " + ( i ) + "' class='pagination-page-button' value=" + ( i ) + ">" + ( i + 1 ) + "</button>";

								}

							}

							pagination += '</div>';
							pagination += '<button class="pagination-page-button next" value="1">Next</button>'

							pagination += '<input type="hidden" class="last-name" value=' + lastName + ' />'
							pagination += '<input type="hidden" class="email" value=' + email + ' />'
							pagination += '<input type="hidden" class="current-page" value=' + 1 + ' />'
							pagination += '<input type="hidden" class="offset" value=' + data.offset + ' />'

							$( '.template-page-body-order-inner-footer-order-status-pagination' ).html( pagination );

						}


					} else {

						$( '.loader' ).toggleClass( 'active' );

						$( '.template-page-body-order-inner-footer' ).addClass( 'active' );
						$( '.template-page-body-order-inner-footer-order-status-table-error' ).html( '<div class="card-notice block p-5 my-8 border border-green-default bg-white text-center rounded wg-translate"><p>No orders found.</p></div>' );
						$( '.template-page-body-order-inner-footer-order-status-table-error' ).toggleClass( 'active' );

					}

				},
				error : function( err ){
					console.log( err );
					window.theme.functions.triggerAlert( 'Sorry an error occurred.', 'error' );
				}
			});

		}

		return false;

	});


	// pagination next/prev page function
	$( document ).on( 'click', '.pagination-page-button', function( event ) {

		$( '.loader' ).toggleClass( 'active' );

		var formData = $( '.order-status-form' );

		var lastName = $( '.last-name' ).val();
		var email = $( '.email' ).val();
		var currentPage = $( '.current-page' ).val();
		var offset = $( this ).val();
		if( offset !== 0 ){

			offset = offset * 100

		}
		var apiUrl = formData[ 0 ].dataset.api;
		var apiBearerToken = formData[ 0 ].dataset.bearer;
		var apiDomain = formData[ 0 ].dataset.domain;

		var headers = {
			'Accept' : 'application/json',
					'Content-type' : 'application/json',
					'X-Shopify-Shop-Domain' : apiDomain,
					'Authorization' : 'Bearer ' + apiBearerToken
		}

		$.ajax({
			url : window.theme.yes_video_api_url + '/api/v1/order_status?last_name=' + lastName + '&search_term=' + email + '&offset=' + ( offset ),
			headers : {
				'Accept' : 'application/json',
				'Content-type' : 'application/json',
				'X-Shopify-Shop-Domain' : window.theme.yes_video_api_x_domain,
				'Authorization' : 'Bearer ' + window.theme.yes_video_bearer_token
			},
			type : 'GET',
			dataType : 'json',
			success : function( data ) {

				var results = '';

				if( data.orders.length > 0 ){

					$.each( data.orders, function( i, order ){

						results += renderLineItem( order, email );

					});

					$( '.template-page-body-order-inner-footer-order-status-table-body' ).html( results );

					if( data.current_page - 1 !== 0 ){

						var pagination = '<button class="pagination-page-button previous" value=' + ( data.current_page - 2 ) + '>Previous</button>'

					} else {

						var pagination = '<button class="pagination-page-button previous" disabled>Previous</button>'

					}

					pagination += '<div>';

					for ( var i = 0; i < data.total_pages; i++ ) {

						if( event.target.value == i ) {

							pagination += '<button aria-label="page ' + ( i ) + '" class="pagination-page-button active" value=' + ( i ) + '><strong>' + ( i + 1 ) + '</strong></button>'

						} else {

							pagination += '<button aria-label="page ' + ( i ) + '" class="pagination-page-button" value=' + ( i ) + '>' + ( i + 1 ) + '</button>'

						}


					}

					pagination += '</div>';

					if( data.current_page !== data.total_pages ){

						pagination += '<button class="pagination-page-button next" value=' + ( data.current_page ) + '>Next</button>'

					} else {

						pagination += '<button class="pagination-page-button next" disabled>Next</button>';

					}

					pagination += '<input type="hidden" class="last-name" value=' + lastName + ' />'
					pagination += '<input type="hidden" class="email" value=' + email + ' />'
					pagination += '<input type="hidden" class="current-page" value=' + data.current_page + ' />'
					pagination += '<input type="hidden" class="offset" value=' + data.offset + ' />'

					$( '.template-page-body-order-inner-footer-order-status-pagination' ).html( pagination );

					$( '.loader' ).toggleClass( 'active' );

				}

			},
			error : function( err ){

				window.theme.functions.triggerAlert( 'Sorry an error occurred.', 'error' );

			}
		});

	});

})();
